module.exports = __webpack_public_path__ + "static/media/cat4.37dec08f.png";